import axios from 'axios'
import { isObject, isEmpty } from 'lodash'
import { snakecase, camelcase } from '../_utils/camelcase'
import { state } from 'src/store.js'
import Toast from 'src/components/common/Toast/index'
import Cookies from 'js-cookie'
import i18n from 'src/i18n'

axios.defaults.timeout = 60000

axios.interceptors.request.use(function (config) {
  const { user } = state
  if (/\/api[2]?\/0\.1/.test(config.url) && user.token && user.token.key) {
    config.headers.Authorization = `Token ${user.token.key}`
  }
  if (config.data instanceof FormData) { // 对图片上传做时间限制
    config.timeout = 2 * 60 * 1000
  }
  if (config.data && !(config.data instanceof FormData)) {
    try {
      config.data = snakecase(config.data, !isObject(config.data))
    } catch (err) {
      console.error(err)
    }
  }
  return config
})

axios.interceptors.response.use(
  /**
   * 此处需注意，后端已经统一处理返回值，请求成功均为200，4XX-5XX的错误放在error中catch
   * @param response
   * @returns {*}
   */
  function (response) {
    let data = response.data || {}
    data = camelcase(data)
    if (data.data) {
      data = data.data
    }
    if (data.errors) {
    }
    return data
  },
  function (err) {
    if (err.code === 'ECONNABORTED') { // 处理请求超时
      console.log(JSON.stringify(err))
      Toast({
        message: i18n.t('networkError.timeout')
      })
      return Promise.reject(new Error({ timeout: true }))
    }
    const { response } = err
    let errorCode = ''
    let status = ''
    if (!isEmpty(response) && isObject(response)) { // 存在错误内容
      try {
        if (typeof window !== 'undefined' && typeof window.gtag === 'function') {
          window.gtag('event', 'exception', {
            description: 'api_network_error: ' + JSON.stringify(response).slice(0, 150),
            fatal: false
          })
        }
      } catch (e) {}
      status = response.status
      if (response.data.errors) {
        errorCode = response.data.errors.code
      }

      errorHandle(status)
    }
    return Promise.reject(Error({
      errors: true,
      code: errorCode
    }))
  }
)

function errorHandle (status) {
  switch (status) {
    case 400:
      console.log('Bad Request')
      Toast({
        message: i18n.t('networkError.badRequest')
      })
      break
    case 401:
      Toast({
        message: i18n.t('networkError.unauthorized')
      })
      Cookies.set('test_user', {}, { domain: '.ipastbook.com' })
      Cookies.set('m_user', {}, { domain: '.ipastbook.com' })
      Cookies.remove('m_user')
      Cookies.remove('test_user')
      window.location.href = '/'
      break
    case 403:
      console.log('Forbidden')
      Toast({
        message: i18n.t('networkError.forbidden')
      })
      break
    case 404:
      console.log('Not Found')
      Toast({
        message: i18n.t('networkError.notFound')
      })
      break
    case 500:
      console.log('Server Error')
      Toast({
        message: i18n.t('networkError.serverError')
      })
      return
    case status > 503:
      console.log('CDN Error')
      break
    default:
      Toast({
        message: i18n.t('networkError.defaultError', { status })
      })
      console.log('Request Error')
  }
}

export default axios
